import styled from 'styled-components'
import { breakpoints } from '../../../../constants/breakpoits.constants'
import {
	BLUE,
	PRIMARY_COLOR,
	DARKORANGE,
} from '../../../../styles/colors.style'

export const StyledMuvibusInfo = styled.section`
	width: 100%;
	padding-bottom: 4rem;
	.title-info {
		font-weight: 600;
		text-align: center;
		margin: 4rem 0;
		color: ${BLUE};

		div:first-child {
			font-size: 4rem;
			padding-bottom: 2rem;
		}

		div:last-child {
			width: 500px;
			font-size: 3rem;
			margin-left: auto;
			margin-right: auto;
			padding-bottom: 1rem;
			@media (max-width: ${breakpoints.MOBILE}px) {
				width: 97vw;
			}
		}
	}
	.content {
		margin: auto;
		text-align: center;
		max-width: 80vw;
		display: flex;
		flex-direction: row;
		color: ${BLUE};
		padding-bottom: 3rem;
		p {
			color: ${BLUE};
			max-width: 350px;
		}

		@media (max-width: ${breakpoints.MOBILE}px) {
			display: block;
			max-width: 97vw;
			div {
				margin-top: 5rem;
			}
			p {
				max-width: initial;
			}
		}

		h3 {
			min-width: 200px;
		}
	}
`
